/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "person": {
        "nested": {
          "whitelabel": {
            "nested": {
              "WhiteLabelDevice": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "platform": {
                    "type": "squareup.person.whitelabel.WhiteLabelDevice.Platform",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pushToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Platform": {
                    "values": {
                      "UNKNOWN": 0,
                      "IOS": 1,
                      "ANDROID": 2
                    }
                  }
                }
              },
              "WhiteLabelOptions": {
                "fields": {
                  "bundleIdentifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "device": {
                    "type": "squareup.person.whitelabel.WhiteLabelDevice",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.person?.nested?.whitelabel?.nested?.WhiteLabelDevice && !$root.nested?.squareup?.nested?.person?.nested?.whitelabel?.nested?.WhiteLabelDevice?.nested?.Platform && !$root.nested?.squareup?.nested?.person?.nested?.whitelabel?.nested?.WhiteLabelOptions) {
  $root.addJSON(jsonData);
}

/**
 * A white label device is a regular Device that has been augmented with a push token.
 *
 * SOURCE WhiteLabelDevice @ squareup/person/whitelabel.proto at 16:1
 */
export const WhiteLabelDevice = $root.lookupType('squareup.person.whitelabel.WhiteLabelDevice');
fixType(WhiteLabelDevice, {
  id: {
    notEmpty: true
  },
  platform: {
    required: true
  }
});
Builder.createAndAttachToType(WhiteLabelDevice);
/**
 * SOURCE Platform @ squareup/person/whitelabel.proto at 17:2
 */
WhiteLabelDevice.Platform = $root.lookupEnum('squareup.person.whitelabel.WhiteLabelDevice.Platform').values;
/**
 * Key-value mapping of bundle identifiers to the buyer's preferences and settings.
 *
 * SOURCE WhiteLabelOptions @ squareup/person/whitelabel.proto at 31:1
 */
export const WhiteLabelOptions = $root.lookupType('squareup.person.whitelabel.WhiteLabelOptions');
fixType(WhiteLabelOptions, {
  bundleIdentifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WhiteLabelOptions);